




















import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import axios, { resHandle } from "@/plugins/axios";
@Component({})
export default class SelectMultiSearch extends Vue {
  @Prop()
  private message: any;
  private resultOptions: any[] = [];
  @Prop()
  private type: any;
  @Prop()
  private pl: any;
  @Prop()
  private size: any;
  private messageChange(ev) {
    this.$emit("update:message", ev);
  }
  /**
   * @description 搜索
   */
  private fetchOptions(ev) {
    if (this.type === "分组标签") {
      axios.get("api/zwb/user/tags").then(({ data }) => {
        resHandle(this, data).then(() => {
          if (this.message && this.message.length > 0) {
            const arr: any[] = _.cloneDeep(this.message);
            arr.map((item: any) => {
              data.data.push(item);
            });
            this.$emit("update:message", arr);
          }
          this.resultOptions = _.uniqBy(data.data, "id");
        });
      });
    } else {
      const params: any = {
        params: {
          type: this.type,
          search: ev
        }
      };
      axios.get("api/project/terms", params).then(({ data }) => {
        resHandle(this, data).then(() => {
          if (this.message && this.message.length > 0) {
            const arr: any[] = _.cloneDeep(this.message);
            arr.map((item: any) => {
              data.data.push(item);
            });
            this.$emit("update:message", arr);
          }
          this.resultOptions = _.uniqBy(data.data, "id");
        });
      });
    }
  }
}
